import { createFileRoute } from '@tanstack/react-router'

import { AuthResetPasswordPage } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/reset-password')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthResetPasswordRoute
})

function TenantAuthResetPasswordRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthResetPasswordPage
      digitalProductId={tenant?.digitalProductId ?? undefined}
    />
  )
}
